<template>
  <div>
    <div class="d-flex mb-5 flex-wrap">
      <div class="ml-auto">
        <b-button
          class="font-weight-bolder btn-icon mr-2"
          variant="light-primary"
          v-on:click="deleteTeacher"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/General/Trash.svg" /> </span
        ></b-button>
        >
      </div>
    </div>
    <CommonFacialDeviceUserTable
      :items="items"
      :pagination="pagination"
      :is-busy="isBusy"
      @changePage="handlePageChange"
      :caption="caption"
      @onChecked="handleCheckbox"
    ></CommonFacialDeviceUserTable>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CommonFacialDeviceUserTable from "@/modules/school/components/device/facial/user/common/CommonFacialDeviceUserTable";

export default {
  name: "SchoolFacialTeacherTable",
  components: { CommonFacialDeviceUserTable },
  props: {
    device: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isBusy: false,
      teacher: [],
      caption: {
        main: "No Teacher Added",
        sub: "To add teacher to this device, go to List",
      },
    };
  },
  mounted() {
    this.fetch();
  },

  methods: {
    fetch() {
      const payload = {
        id: this.device.id,
      };
      this.isBusy = true;
      this.$store
        .dispatch("fetchFDTeacherListIn", payload)
        .then(() => {})
        .finally(() => (this.isBusy = false));
    },

    handlePageChange(page) {
      console.log("Current Page is", page);
      this.$store.commit("setFDTeacherListPage", page);
      this.fetch();
    },

    /**
     * Call store to change selected value for item
     */
    handleCheckbox(data, state) {
      console.log("Emitting from checkbox", data.id, state);
      this.$store.dispatch("changeTeacherSelectedStatus", {
        id: data.id,
        currentState: state,
      });
    },

    /**
     * Delete Teacher
     */
    deleteTeacher() {
      this.items.forEach((e) => {
        if (e.selected) {
          this.teacher.push(e.id);
        }
      });

      console.log("Final Teacher Id: ", this.teacher);

      this.isBusy = true;
      this.$store
        .dispatch("deleteTeacherFacialDevice", {
          fd_id: this.device.id,
          school_employee: this.teacher,
        })
        .then(() => {
          this.$bvToast.toast("Successfully delete teacher to device.", {
            title: "Success",
            solid: true,
            variant: "success",
            autoHideDelay: 5000,
          });
        })
        .catch(() => {
          this.$bvToast.toast("Failed to delete teacher to device.", {
            title: "Failed",
            variant: "danger",
            headerClass: "h4",
            autoHideDelay: 5000,
          });
        })
        .finally(() => {
          this.teacher = [];
          this.isBusy = false;
          this.fetch();
        });
    },
  },

  computed: {
    ...mapGetters({
      items: "getFDTeacherList",
      pagination: "getFDTeacherListPagination",
    }),
  },
};
</script>

<style scoped></style>
